module.exports = __webpack_public_path__ + "img/typhoon_orange.f4d5e51f.gif";